import { ArrowDownIcon, ArrowRightIcon } from '@heroicons/react/24/outline'

import person from '../../../../../../assets/images/illustrations/person-heart-without-shapes.png'
import { anim, prog } from '../../../../motion'
import { Line } from '../../../../v2/kit'
import { useCopy, useGoTo, useLang, useTheme } from '../../../i18n'
import { Magnetic, MaskText } from '../../stage/fx'

// Erst ein Herz aus Formen, dann zerspringt es in Konfetti und die Headline kommt
const heart = (w, h, narrow) => ({
  type: 'heart',
  x: w / 2,
  y: narrow ? h * 0.42 : h * 0.46,
  size: narrow ? w * 0.74 : Math.min(h * 0.62, w * 0.42),
  dot: 0.85
})

export const HERO_PARTICLES = [
  [0, heart],
  [0.1, heart],
  [0.32, () => ({ type: 'scatter', alpha: 0.6, seed: 51 })],
  [1, () => ({ type: 'scatter', alpha: 0.3, seed: 53 })]
]

export default function CsHero() {
  const c = useCopy('hero')
  const s = useCopy('show')
  const ui = useCopy('ui')
  const goTo = useGoTo()
  const lang = useLang()
  const theme = useTheme()
  const demoHref = `${window.location.pathname}?v=demo-showcase${theme === 'light' ? '-hell' : ''}${
    lang === 'en' ? '&lang=en' : ''
  }`

  return (
    <div className='sc-full'>
      <div
        className='cs-hero__kicker'
        style={anim({ at: [-1, 0], out: [0.08, 0.14], oy: -30 })}
      >
        <span className='sc-eyebrow'>{s.kicker}</span>
      </div>

      <div className='cs-hero__text'>
        <Line at={[0.16, 0.22]} className='sc-eyebrow'>
          {s.kicker}
        </Line>
        <h1 className='sc-display cs-hero__title'>
          <span>
            <MaskText text={c.lines[0]} at={[0.14, 0.22]} />
          </span>
          <span>
            <MaskText text={c.lines[1]} at={[0.18, 0.26]} />
          </span>
          <span className='sc-grad'>
            <MaskText text={c.lines[2]} at={[0.24, 0.32]} />
          </span>
        </h1>
        <Line at={[0.32, 0.38]} y={20} className='sc-lead cs-hero__copy'>
          {c.text}
        </Line>
        <div
          className='cs-hero__actions'
          style={anim({ at: [0.36, 0.42], y: 20 })}
        >
          <Magnetic
            as='button'
            type='button'
            className='sc-btn'
            onClick={() => goTo('ablauf')}
          >
            {c.ctaFlow}
          </Magnetic>
          <Magnetic
            as='button'
            type='button'
            className='sc-btn sc-btn--ghost'
            onClick={() => goTo('faq')}
          >
            {c.ctaFaq}
          </Magnetic>
        </div>
        <a
          className='cs-company'
          href={demoHref}
          style={anim({ at: [0.42, 0.48], y: 10 })}
        >
          <span className='cs-company__dot' />
          {c.company} <b>{c.companyLink}</b>
          <ArrowRightIcon width={14} height={14} />
        </a>
      </div>

      <div
        className='cs-hero__art'
        style={{
          ...prog([0.3, 1]),
          ...anim({ at: [0.28, 0.4], y: 120, s: 0.85 })
        }}
      >
        <img src={person} alt='' />
      </div>

      <div
        className='sc-cue cs-cue'
        style={anim({ at: [-1, 0], out: [0.03, 0.08], oy: 20 })}
      >
        <ArrowDownIcon width={16} height={16} />
        {ui.cue}
      </div>
    </div>
  )
}
